/* eslint-disable import/no-cycle */
/* eslint-disable no-param-reassign */
import { createSlice, PayloadAction } from '@reduxjs/toolkit';

import { State } from '@/apps/appCreator/store';

type TCredit = {
  id: string;
  title: string;
  tags: string[];
};

type TFormState = {
  form: {
    period: {
      value: number;
    };
  };
  credits: {
    credits: TCredit[];
    monthPayment?: string;
    current?: string;
    rate?: string;
  };
};

type SliceState = {
  loaded: boolean;
  formState?: TFormState;
};

const initialState: SliceState = {
  loaded: false,
};

const creditCalcSlice = createSlice({
  name: 'creditCalc',
  initialState,
  reducers: {
    success: state => {
      state.loaded = true;
    },
    updateFormState: (state, action: PayloadAction<any>) => {
      state.formState = action.payload;
    },
  },
});

const selectState = (state: State) => state.creditCalc;

const selectors = {
  selectState,
};

const actions = {
  ...creditCalcSlice.actions,
};

export { creditCalcSlice as default, actions, selectors };
